import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Share } from '@capacitor/share';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'web', 'android', 'ios'

// Push Notifications (native)
export const initNativePush = async (onTokenReceived) => {
  if (!isNative) return;

  const permResult = await PushNotifications.requestPermissions();
  if (permResult.receive !== 'granted') return;

  await PushNotifications.register();

  PushNotifications.addListener('registration', (token) => {
    console.log('Push token:', token.value);
    if (onTokenReceived) onTokenReceived(token.value);
  });

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Push received:', notification);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.log('Push action:', action);
  });
};

// Camera
export const takePhoto = async () => {
  if (!isNative) return null;
  try {
    const photo = await Camera.getPhoto({
      quality: 80,
      resultType: CameraResultType.Uri,
      source: CameraSource.Prompt,
      allowEditing: false
    });
    return photo.webPath;
  } catch (e) {
    console.log('Camera cancelled:', e);
    return null;
  }
};

// Share
export const shareContent = async (title, text, url) => {
  try {
    await Share.share({ title, text, url });
  } catch (e) {
    console.log('Share cancelled:', e);
  }
};

// Haptics
export const hapticFeedback = async (style = 'light') => {
  if (!isNative) return;
  try {
    await Haptics.impact({
      style: style === 'heavy' ? ImpactStyle.Heavy : style === 'medium' ? ImpactStyle.Medium : ImpactStyle.Light
    });
  } catch (e) {
    // Silently fail on unsupported devices
  }
};

// Status Bar
export const setDarkStatusBar = async () => {
  if (!isNative) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#1e293b' });
  } catch (e) {}
};

// Splash Screen
export const hideSplash = async () => {
  if (!isNative) return;
  try {
    await SplashScreen.hide();
  } catch (e) {}
};
